import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import FormikSelectTwo, {
  SelectProductWithError,
} from "../../../../Components/Utils/Select";
import {
  NuDate,
  NuInput,
  NuInputWithError,
  NuTextArea,
} from "../../../../Components/Utils/Input";
import useEditFormData from "../../../../Components/Hooks/useEditFormData";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import { useToast } from "../../../../Components/Others/ToastServices";
import Attachement, {
  videotype,
} from "../../../../Components/Utils/CustomAttrachmentupload";
import Pdf from "../../../../Components/Icons/Pdf";
import Txt from "../../../../Components/Icons/Txt";
import Xls from "../../../../Components/Icons/Xls";
import Doc from "../../../../Components/Icons/Doc";
import Video from "../../../../Components/Icons/Video";
import CloseIcon from "../../../../Components/Icons/Close";
import DropDownAddMetaData, {
  DropDownAddUnitWithError,
} from "../../../../Components/Utils/selectAddMetaData";
import DeleteIcon from "../../../../Components/Icons/Delete";
import EditIcon from "../../../../Components/Icons/Edit";
import Select from "react-select";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import UseDropDownNew from "../../../../Components/Hooks/useDropDownNew";
import MultiSelect from "../../../../Components/Utils/MultiSelect";
import axiosInstance from "../../../../Services/axiosCommon";
import UseEqupiProductDropDownNew from "../../../../Components/Hooks/useEqupiProductDropDown";
import { SettingHeading } from "../../../../Components/Utils/Settingheading";

function EditContractsTest() {
  const navigate = useNavigate();
  const { contractsEditId } = useParams();
  const location = useLocation();
  const from = location.state?.from || "/Contract-management/contracts";
  const toast = useToast();

  // Dropdowns and metadata
  const { data: client } = UseDropDown(`/clients/drop-down`);
  const { data: form } = UseDropDownNew(`/form/drop-down`);
  const { data: Survey } = UseDropDown(`/survey-report/drop-down`);
  const { value: Location, getData: reflocation } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Inspection_Location"
  );
  const { value: unit, getData: refunit } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "unit_equipments"
  );
  const { value: equipments, getData: refEquipments } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "equipments"
  );
  const { value: status, getData: refstatus } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Status_Contracts"
  );
  const { value: inspectionTypeOptions, getData: refinspectionType } =
    useFetchMataData(
      `/dropdown/dropdown-details/`,
      "Inspection_Type_Contracts"
    );
  const [searchEquipment, setSearchEquipment] = useState("");
  const [search, setSearch] = useState("");
  const { data: Item, setData } = UseEqupiProductDropDownNew(
    `/equipments/drop-down`,
    search
  );

      const {value:paymentTerms ,getData:refpaymentTerms} = useFetchMataData(`/dropdown/dropdown-details/`,'paymentTerms')


  const { Oncancel, editFormData, isLoading } = useEditFormData();
  const [items, setItem] = useState([]); // For Inspection Schedule new additions
  const [Equipitems, setEquipItems] = useState([]); // For Equipment Detail new additions
  const [inspection, setinspection] = useState([]); // For Equipment Detail new additions

  const [isEditable, setIsEditable] = useState(false);
  const [isEditableinsp, setIsEditableinsp] = useState(false);

  const [isEditQua, setIsEditQua] = useState(false);
  const [isEditUnit, setIsEditUnit] = useState(false);
  const [error, setError] = useState("");
  const [productError, setProductError] = useState("");
  const [unitError, setUnitError] = useState("");
  const [quantityError, setQuantityError] = useState("");
  const [sortedProList, setSortedProList] = useState([]);
  const [oldData, setOldData] = useState([]);
  const [createNew, setCreateNew] = useState({
    clientId: "",
    srId: null,
    description: "",
    amount: "",
    duration: "",
    startDate: "",
    endDate: "",
    renewalDate: "",
    status: "",
    equipments: [],
    schedules: [],
    inspection: [],
    attachments: [],
    refNumber: "",
    filesToRemove: [],
      buildingName:'',
    notes:"",
    paymentTerms:"",
    noticePeriod:""
  });

  const { value: facilities, getData: reffacilities } = useFetchMataData(
      `/dropdown/dropdown-details/`,
      "Facilities_Contracts"
    );

  const [filePathList, setFilePathList] = useState([]);
  const [fileRemoveList, setFileRemoveList] = useState([]);
  const [image, setImage] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);

  // Fetch contract data
  function getView() {
    axiosInstance
      .get(`/contract/${contractsEditId}`)
      .then((res) => {
        const contractData = res?.data?.data || {};
        setCreateNew({
          clientId: contractData.clientId || "",
          srId: contractData.srId || null,
          description: contractData.description || "",
          amount: contractData.amount || "",
          duration: contractData.duration || "",
          startDate: contractData.startDate || "",
          endDate: contractData.endDate || "",
          renewalDate: contractData.renewalDate || "",
          status: contractData.status || "",
          equipments: contractData.equipments || [],
          schedules: contractData.schedules || [],
          inspection: contractData.inspection || [],
          attachments: contractData.attachments || [],
          refNumber: contractData.refNumber || "",
          filesToRemove: [],
            buildingName:contractData.buildingName ||'',
    notes:contractData.notes ||"",
    paymentTerms:contractData.paymentTerms ||"",
    noticePeriod:contractData.noticePeriod ||"",

        });
      })
      .catch((err) => {
        console.log("Error fetching contract:", err);
      });
  }

  useEffect(() => {
    getView();
  }, []);

  const validationSchema = yup.object({
    duration: yup.string().required("Duration is required!"),
    clientId: yup.string().required("Client is required!"),
    startDate: yup.date().required("Start date is required"),
    endDate: yup
      .date()
      .required("End date is required")
      .min(yup.ref("startDate"), "End date must be after start date"),
    inspectionDates: yup.array().of(
      yup.object().shape({
        date: yup
          .date()
          .required("Date is required")
          .test(
            "within-range",
            "Date must be between contract start and end",
            function (value) {
              const { startDate, endDate } = this.options.context;
              if (!value || !startDate || !endDate) return false;
              const dateVal = new Date(value);
              return (
                dateVal >= new Date(startDate) && dateVal <= new Date(endDate)
              );
            }
          ),
      })
    ),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema,
    context: {
      startDate: createNew.startDate,
      endDate: createNew.endDate,
    },
    onSubmit: async (value, { resetForm }) => {
      let formData = new FormData();
      const valueWithItems = {
        ...value,
        equipments: [...createNew.equipments, ...Equipitems],
        inspectionDetails: [...createNew.inspection, ...inspection],
        filesToRemove: fileRemoveList,
      };
      formData.append("json_data", JSON.stringify(valueWithItems));
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
      await editFormData({
        url: `/contract/edit-contract/${contractsEditId}`,
        formData: formData,
        navigateUrl: from,
        resetForm: resetForm,
      });
    },
  });

  // Fetch survey reports based on client
  const [Newcontract, setContract] = useState([]);
  function getViewSurvey(clientId) {
    axiosInstance
      .get(`/survey-report/drop-down/client/${clientId}`)
      .then((res) => {
        const formattedContracts =
          res.data?.map((item) => ({
            value: item.id,
            label: item.name,
          })) || [];
        setContract(formattedContracts);
      })
      .catch((err) => {
        console.log("Error fetching survey reports:", err);
      });
  }

  useEffect(() => {
    if (formik.values.clientId) {
      getViewSurvey(formik.values.clientId);
    } else {
      setContract([]);
    }
  }, [formik.values.clientId]);

  // Update file path list for attachments
  useEffect(() => {
    if (
      createNew?.attachments &&
      createNew?.attachments !== "None" &&
      createNew?.attachments !== "[]"
    ) {
      setFilePathList(createNew.attachments);
    }
  }, [createNew?.attachments]);




   const [addInspection, setAddInspection] = useState({
    equipmentId: "",
    location: "",
    inspectionType: "",
    formSelection: "",
  });

  const formikAddInspection = useFormik({
    initialValues: addInspection,
    validateOnChange: false,
    validateOnBlur: false,
  });

const handleAdd = () => {
  console.log("Add button clicked");
  console.log("formik values:", formikAddInspection.values);

  let hasError = false;
  if (!formikAddInspection.values.equipmentId) {
    setProductError("Equipment is required");
    hasError = true;
  } else {
    setProductError("");
  }

  if (hasError) return;

  // Find the selected equipment from the activity list
  const selectedEquipment = activity.find(
    (item) => String(item.value) === String(formikAddInspection.values.equipmentId)
  );

  const newItem = {
    equipmentId: String(formikAddInspection.values.equipmentId).trim(),
    productName: selectedEquipment ? selectedEquipment.label : "Unknown Item",
    location: (formikAddInspection.values.location || "").trim(),
    inspectionType: (formikAddInspection.values.inspectionType || "").trim(),
    formSelection: formikAddInspection.values.formSelection || [],
  };

  // ✅ check if same data already exists
  const isDuplicate = inspection.some(
    (it) =>
      String(it.equipmentId).trim() === newItem.equipmentId &&
      String(it.location).trim() === newItem.location &&
      String(it.inspectionType).trim() === newItem.inspectionType &&
      JSON.stringify(it.formSelection) === JSON.stringify(newItem.formSelection)
  );

  if (isDuplicate) {
    toast.open({
      type: "warning",
      description: "This item already exists.",
      message: `Duplicate item`,
    });
    return;
  }

  // ✅ add item
  const updatedInspection = [...inspection, newItem];
  setinspection(updatedInspection);
  console.log("Updated inspection list:", updatedInspection);

  // Reset only the inspection form, not the main form
  formikAddInspection.resetForm({
    values: {
      equipmentId: "",
      location: "",
      inspectionType: "",
      formSelection: [],
    },
  });

  setError("");
};


 


  // Handle delete for both sections
  const handleDeleteItem = (indexToDelete, section, isExisting = false) => {
    if (section === "inspection") {
      if (isExisting) {
        const deletedItem = createNew.inspection[indexToDelete];
        const updatedDetails = createNew.inspection.filter(
          (_, index) => index !== indexToDelete
        );
        setCreateNew((prev) => ({
          ...prev,
          inspection: updatedDetails,
        }));
        if (deletedItem) {
          setData([
            ...Item,
            { value: deletedItem.equipmentId, label: deletedItem.productName },
          ]);
        }
      } else {
        const deletedItem = inspection[indexToDelete];
        const updatedItems = inspection.filter(
          (_, index) => index !== indexToDelete
        );
        setinspection(updatedItems);
        if (deletedItem) {
          setData([
            ...Item,
            { value: deletedItem.equipmentId, label: deletedItem.productName },
          ]);
        }
      }
    } else {
      if (isExisting) {
        const deletedItem = createNew.equipments[indexToDelete];
        const updatedEquipments = createNew.equipments.filter(
          (_, index) => index !== indexToDelete
        );
        setCreateNew((prev) => ({
          ...prev,
          equipments: updatedEquipments,
        }));
        if (deletedItem) {
          setData([
            ...Item,
            { value: deletedItem.equipmentId, label: deletedItem.productName },
          ]);
        }
      } else {
        const deletedItem = Equipitems[indexToDelete];
        const updatedItems = Equipitems.filter(
          (_, index) => index !== indexToDelete
        );
        setEquipItems(updatedItems);
        if (deletedItem) {
          setData([
            ...Item,
            { value: deletedItem.equipmentId, label: deletedItem.productName },
          ]);
        }
      }
    }
  };

  // Attachment handling
     function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];

    files.forEach((item) => {
      if (item.size < maxFileSize) {  
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size too big`,
          description: `${item.name} is removed and not uploaded`,
        });
      }
    });

    setSelectedFile(fileArr);


    setImage(fileArr);
    e.target.value = null;
  }

  const removeImages = (value) => {
    let List = selectedFile.filter((item) => item?.name !== value?.name);
    setSelectedFile([...List]);
    setImage(List);
  };

  function UpdateAttachmentList(item) {
    let filterList = filePathList.filter((itemList) => itemList.file !== item);
    let removeFile = filePathList.find((itemList) => itemList.file === item);
    setFileRemoveList([...fileRemoveList, removeFile.file]);
    setFilePathList(filterList);
  }

 

  // Formik setup

  // Date calculations
  const getDaysFromDuration = (duration) => {
    const value = parseInt(duration.split(" ")[0]);
    return value * 30;
  };

  const calculateEndDateFromDays = (startDate, duration) => {
    const daysToAdd = getDaysFromDuration(duration);
    const date = new Date(startDate);
    date.setDate(date.getDate() + daysToAdd - 1);
    return date.toISOString().split("T")[0];
  };

  const [minRenewalDate, setMinRenewalDate] = useState(null);

  useEffect(() => {
    const { duration, startDate } = formik.values;
    if (duration && startDate) {
      const calculatedEndDate = calculateEndDateFromDays(startDate, duration);
      formik.setFieldValue("endDate", calculatedEndDate);
      formik.setFieldValue("renewalDate", calculatedEndDate);
      setMinRenewalDate(calculatedEndDate);
    }
  }, [formik.values.duration, formik.values.startDate]);

  useEffect(() => {
    const { endDate } = formik.values;
    if (endDate) {
      formik.setFieldValue("renewalDate", endDate);
    }
  }, [formik.values.endDate]);

  const [showPopupEquipment, setShowPopupEquipment] = useState(false);
  const togglePopupEqupiment = () => {
    setShowPopupEquipment(!showPopupEquipment);
  };
  const handlePopupSubmitEquipmt = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append(
      "json_data",
      JSON.stringify({
        name: formik.values.name || "",
        brand: formik.values.brand || "",
        unit: formik.values.unit || "",
        model: formik.values.model || "",
      })
    );
    try {
      const response = await axiosInstance.post(
        "/equipments/new-equipment",
        formData
      );
      const createdEquipt = response.data?.data;

      setData((prevEquipments) => [
        {
          label: formik.values.name || "-",
          value: createdEquipt,
        },
        ...prevEquipments,
      ]);

      // Clear and close popup
      formik.setFieldValue("name", "");
      formik.setFieldValue("brand", "");
      formik.setFieldValue("unit", "");
      formik.setFieldValue("model", "");
      togglePopupEqupiment();
    } catch (error) {
      console.error("Error creating new equipment:", error);
    }
  };

 
  const handlDeleteItem = (indexToDelete) => {
    const updatedItems = inspection.filter(
      (_, index) => index !== indexToDelete
    );
    const deletedItem = inspection.find((_, i) => i === indexToDelete);
    setinspection(updatedItems);

    // Ensure correct format before pushing back to dropdown options
    if (deletedItem?.equipmentId && deletedItem?.productName) {
      const restoredItem = {
        value: deletedItem.equipmentId,
        label: deletedItem.productName,
      };
      setData((prev) => [...prev, restoredItem]);
    }
  };

  const handlDeleteExistItem = (indexToDelete) => {
    const updatedItems = createNew.inspection.filter(
      (_, index) => index !== indexToDelete
    );
    const deletedItem = createNew.inspection.find(
      (_, i) => i === indexToDelete
    );

    setCreateNew((prevState) => ({
      ...prevState,
      inspection: updatedItems,
    }));

    const tempDd = deletedItem?.name;
    setData((prev) => [...prev, tempDd]);
  };

  const [activity , setActivity] =useState()
    function getViewItem() {
    axiosInstance
      .get(`/equipments/drop-down`)
      .then((res) => {
      const formattedActivity =
  res.data?.map((item) => ({
    value: item.id,             // for formik (equipmentId)
    label: item.name,           // what shows in dropdown
    refNumber: item.refNumber,  // keep reference number
    unit: item.unit || "-",     // keep unit (fallback "-")
  })) || [];

setActivity(formattedActivity);

      })
      .catch((err) => {
        console.log("err", err);
      });
  }
useEffect(()=>{
  getViewItem()
},[])

  return (
    <div className="w-full h-full py-2 px-4">
      <div className="flex justify-between w-full">
        <Breadcrumb
          items={[
            { name: "Contracts", link: "/Contract-management/contracts" },
            { name: "Edit" },
          ]}
        />
        <BackButton />
      </div>
      <div className="w-full mx-auto h-[calc(100vh-151px)] overflow-y-auto mt-4">
        <form onSubmit={formik.handleSubmit}>
          <div className="w-full h-full flex justify-start rounded-md bg-white content-start flex-wrap py-2 px-4 overflow-y-auto">
            <div className="w-full">
              <SettingHeading title={`Contracts: ${createNew?.refNumber}`} />
            </div>

            <FormikSelectTwo
              label="Client"
              Options={client}
              formik={formik}
              placeholder="Choose"
              name="clientId"
              isRequired={true}
              width="w-full md:w-1/3 md:-mt-2"
                FixPosition={true}
                      PortalTarget={false}
            />
            
            <NuInput
              type="text"
              label="Description"
              placeholder="Type here"
              formik={formik}
              name="description"
              width="w-full md:w-2/3"
            />
            
            <FormikSelectTwo
              label="Survey Report"
              Options={Newcontract}
              formik={formik}
              placeholder="Choose"
              name="srId"
              width="w-full md:w-1/3"
                FixPosition={true}
                      PortalTarget={false}
            />

            <NuInput
              type="text"
              label="Building Name"
              placeholder="Type here"
              formik={formik}
              name="buildingName"
              width="w-full md:w-2/3"
            />

            <NuInput
              type="number"
              label="Amount"
              placeholder="Amount"
              formik={formik}
              name="amount"
              width="w-full md:w-1/3"
            />
            <FormikSelectTwo
              label="Contract Duration"
              placeholder="Choose"
              Options={[
                { value: "1 Month", label: "1 Month" },
                { value: "3 Months", label: "3 Months" },
                { value: "6 Months", label: "6 Months" },
                { value: "12 Months", label: "12 Months" },
                { value: "24 Months", label: "24 Months" },
                { value: "36 Months", label: "36 Months" },
              ]}
              formik={formik}
              name="duration"
              width="w-full md:w-1/3"
              isRequired={true}
                FixPosition={true}
                      PortalTarget={false}
            />
            <NuDate
              label="Contract Start Date"
              placeholder="Contract Start Date"
              formik={formik}
              name="startDate"
              width="w-full md:w-1/3"
              isRequired={true}
              // min={new Date().toISOString().split("T")[0]}
            />
            <NuDate
              label="Contract End Date"
              formik={formik}
              name="endDate"
              width="w-full md:w-1/3 "
              isRequired={true}
              min={minRenewalDate || new Date().toISOString().split("T")[0]}
            />
            <NuDate
              label="Contract Renewal Date"
              formik={formik}
              name="renewalDate"
              width="w-full md:w-1/3"
              isRequired={true}
              min={minRenewalDate || new Date().toISOString().split("T")[0]}
            />

             <NuInput
                          type="number"
                          label="Renewal Notice Period"
                          placeholder="Renewal Notice Period"
                          formik={formik}
                          name="noticePeriod"
                          width="w-full md:w-1/3 "
                        />
            
                         <FormikSelectTwo
                                        label="Payment Terms"
                                        placeholder="Choose"
                                        Options={paymentTerms}
                                        formik={formik}
                                        name="paymentTerms"
                                        width="w-full md:w-1/2 lg:w-1/3 md:-mt-1"
                                        getFunc={refpaymentTerms}
                                        displayProperty={"Payment Terms"}
                                        propertyName={"paymentTerms"}
                                          FixPosition={true}
                      PortalTarget={false}
                                      />
            <DropDownAddMetaData
              label="Status"
              placeholder="Choose"
              Options={status}
              formik={formik}
              name="status"
              width="w-full md:w-1/3 md:-mt-2"
              getFunc={refstatus}
              displayProperty={"Status"}
              propertyName={"Status_Contracts"}
                FixPosition={true}
                      PortalTarget={false}
            />

            
                                    <NuTextArea
                                      label="Notes"
                                      placeholder="Notes"
                                      formik={formik}
                                      name="notes"
                                      new_width="w-full md:w-2/3 "
                        
                                      width="w-full md:w-1/2 lg:w-1/3"
                                    />
            <div className="w-full">
              <SettingHeading title="Attachments :" />
            </div>
            <div className="md:flex justify-between mt-5 px-3 w-full">
              <div className="w-full flex gap-2 items-center flex-wrap">
                {filePathList?.map((imgs, idx) => {
                  let Ext = imgs?.file_name?.split(".").reverse()[0];
                  return (
                    <div
                      className="w-20 h-9 my-2 relative flex justify-center items-center rounded-lg"
                      key={idx}
                      style={{
                        border: "1px solid gray",
                        borderColor: "rgb(148 163 184 / var(--tw-bg-opacity))",
                      }}
                    >
                      <div
                        className="w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-medium flex justify-center items-center -top-2 -right-2 z-10"
                        onClick={() => UpdateAttachmentList(imgs?.file)}
                      >
                        <CloseIcon color="white" height="8" width="8" />
                      </div>
                      <div className="w-20 h-9 flex justify-center items-center rounded-lg overflow-hidden cursor-pointer">
                        <div className="w-8 h-8">
                          {videotype.includes(Ext) ? <Video /> : null}
                          {Ext === ("docx" || "doc" || "txt") ? (
                            <Doc />
                          ) : Ext === ("xlsx" || "xls") ? (
                            <Xls />
                          ) : Ext === "txt" ? (
                            <Txt />
                          ) : Ext === "pdf" ? (
                            <Pdf />
                          ) : Ext === "pptx" ? (
                            <>No file</>
                          ) : (
                            <img src={imgs?.file} alt="#" width="120%" />
                          )}
                        </div>
                        <p className="w-[50px] text-[11px] truncate">
                          {imgs?.file_name}
                        </p>
                      </div>
                    </div>
                  );
                })}
                <Attachement
                  handleChange={handleImageChange}
                  preview={image || ""}
                  width="w-full"
                  label="Attach"
                  multiple={true}
                  removeImages={removeImages}
                />
              </div>
            </div>
          </div>

          {/* Inspection Schedule Section */}
          <div className="w-full mx-auto bg-white rounded-md pb-4 mt-4">
            <div className="w-full h-full flex justify-start content-start flex-wrap mb-4">
              <div className="w-full px-4">
                <SettingHeading title="Inspection Schedule" />
              </div>
              <div className="w-full m-2 border border-solid rounded-lg">
                <div className="md:grid grid-cols-12 gap-1">
                  <div className="col-span-4 pt-2">
                  
                    <SelectProductWithError
                      type="text"
                      label="Facilities / Building"
                      placeholder="Facilities / Building"
                      Options={Item}
                      formik={formikAddInspection}
                      name="equipmentId"
                      width="w-full md:mt-[-7px] z-10"
                      ErrMessage={productError}
                      handleClick={togglePopupEqupiment}
                      hasAddButton={true}
                      setSearch={setSearch}
                      FixPosition={true}
                      PortalTarget={false}
                      //  displayProperty="Facilities / Building"
                      // propertyName="Facilities_Contracts"
                      // getFunc={reffacilities}

                    />
                  </div>
                 
                  <div className="col-span-2">
                    <DropDownAddMetaData
                      label="Location"
                      placeholder="Choose"
                      Options={Location}
                      formik={formikAddInspection}
                      name="location"
                      width="w-full md:mt-[-3px]"
                      getFunc={reflocation}
                      displayProperty="Location"
                      propertyName="Inspection_Location"
                      FixPosition={true}
                      PortalTarget={false}
                    />
                  </div>
                  <div className="col-span-2">
                    <FormikSelectTwo
                      label="Inspection Schedule"
                      placeholder="Choose"
                      Options={[
                        { value: "Monthly", label: "Monthly" },
                        { value: "Quarterly", label: "Quarterly" },
                        { value: "Half-yearly", label: "Half-yearly" },
                        { value: "Yearly", label: "Yearly" },
                      ]}
                      formik={formikAddInspection}
                      name="inspectionType"
                      width="w-full"
                      FixPosition={true}
                      PortalTarget={false}
                    />
                  </div>
                  <div className="col-span-3">
                    <MultiSelect
                      label="Form"
                      Options={form}
                      formik={formikAddInspection}
                      placeholder="Choose"
                      name="formSelection"
                      width="w-full"
                        FixPosition={true}
                      PortalTarget={false}
                    />
                  </div>
                  <div className=" flex  justify-center md:items-end mb-4">
                    <button
                      onClick={handleAdd}
                      type="button"
                      className="px-6 h-8 bg-baseColor-primary text-white text-xs font-medium rounded-lg"
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
              <div className="w-full bg-white overflow-y-scroll mt-5">
                {error && (
                  <p className="text-xs font-semibold text-red-500 px-4">
                    {error}
                  </p>
                )}
                <div className="w-full py-3 bg-baseColor-primary justify-between rounded-lg px-6 hidden md:flex">
                  <p className="w-[5%] text-left text-white text-xs font-medium">
                    S.No
                  </p>
                  <p className="w-[45%] text-left text-white text-xs font-medium">
                    Facilities / Building
                  </p>
                  <p className="w-[22%] text-left text-white text-xs font-medium">
                    Location
                  </p>
                  <p className="w-[23%] text-left text-white text-xs font-medium">
                    Schedule
                  </p>
                    <p className="w-[5%] text-right text-white text-xs font-medium pr-1">
                    Action
                  </p>
                 
                </div>
                <div className="h-[calc(100vh-300px)] overflow-y-scroll hidden md:block">
                  {/* newly one */}
                  {inspection.map((List, index) => (
                    <div
                      key={index}
                      className="w-full odd:bg-white even:bg-gray-100"
                    >
                      <div className="w-full py-2 flex items-center justify-between px-6">
                        <p className="w-[5%] text-left text-xs font-medium text-[#111537] py-2.5">
                          {index + 1}
                        </p>
                        <p className="w-[45%] text-left text-xs font-medium text-[#111537] py-2.5">
                             {List.productName}
                        </p>
                        <p className="w-[22%] text-left text-xs font-medium text-[#111537] py-2.5">
                          {List?.location}
                        </p>
                        <div className=" w-[23%] text-left text-xs font-medium text-[#111537] py-2.5">
                          {List?.inspectionType}
                        </div>

                        <div className="w-[5%] text-right py-2.5">
                          <button
                            onClick={() => handlDeleteItem(index)}
                            type="button"
                            className="text-red-500 cursor-pointer ml-4 border-none"
                          >
                            <DeleteIcon color="red" height={12} />
                          </button>
                        </div>
                      </div>
                      <div className="w-full flex  px-6 pb-3">
                        <p className="w-[5%]"></p>
                       
                        <div className="w-[45%] text-left text-xs font-medium text-[#111537] ">
                         
                          <div className="mt-2 flex gap-2">
                            {List?.formSelection &&
                            List.formSelection.length > 0 ? (
                              List.formSelection
                                .map(
                                  (val) =>
                                    form?.find((item) => item.value === val)
                                      ?.label
                                )
                                .filter(Boolean)
                                .map((label, idx) => (
                                  <div
                                    key={idx}
                                    className="flex items-start gap-2 p-1.5 bg-white border border-gray-200 rounded-md text-xs text-gray-700  transition"
                                  >
                                    <div className="flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-textColor-main font-semibold text-[10px]">
                                      {idx + 1}
                                    </div>
                                    <p className="flex-1">{label}</p>
                                  </div>
                                ))
                            ) : (
                              <div className="text-xs text-[#111537] mt-1">
                                -
                              </div>
                            )}
                          </div>
                        </div>

                        <p className="w-[5%]"></p>
                      </div>
                    </div>
                  ))}

                  {/* Already existing */}
                  {createNew.inspection.map((List, index) => (
                    <div
                      key={index}
                      className="w-full odd:bg-white even:bg-gray-100"
                    >
                      <div className="w-full py-2 flex items-center justify-between px-6">
                        <p className="w-[5%] text-left text-xs font-medium text-[#111537] py-2.5">
                          {index + 1 + inspection.length}
                        </p>
                        <p className="w-[45%] text-left text-xs font-medium text-[#111537] py-2.5">
                          {List?.name}
                        </p>
                        <p className="w-[22%] text-left text-xs font-medium text-[#111537] py-2.5">
                          {List?.location}
                        </p>
                        <div className=" w-[23%] text-left text-xs font-medium text-[#111537] py-2.5">
                          {List?.inspectionType}
                        </div>
                                               <div className="w-[5%] text-right py-2.5">
                          <button
                            onClick={() => handlDeleteExistItem(index)}
                            type="button"
                            className="text-red-500 cursor-pointer ml-4 border-none"
                          >
                            <DeleteIcon color="red" height={12} />
                          </button>
                        </div>
                      </div>

                      {/* Inspection Type and Forms */}
                      <div className="w-full flex  px-4 pb-3">
                        <p className="w-[5%]"></p>
                       
                        <p className="w-[45%] text-left text-xs font-medium text-[#111537] py-1  p-2 ">
                        
                          <div className="mt-2 flex gap-2">
                            {List?.formSelection &&
                            List?.formSelection.length > 0 ? (
                              List.formSelection
                                .map(
                                  (val) =>
                                    form?.find((item) => item.value === val)
                                      ?.label
                                )
                                .filter(Boolean)
                                .map((label, idx) => (
                                  <div
                                    key={idx}
                                    className="flex items-start gap-2 p-1.5 bg-white border border-gray-200 rounded-md text-xs text-gray-700  transition"
                                  >
                                    <div className="flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-textColor-main font-semibold text-[10px]">
                                      {idx + 1}
                                    </div>
                                    <p className="flex-1">{label}</p>
                                  </div>
                                ))
                            ) : (
                              <div className="text-xs text-[#111537] mt-1">
                                -
                              </div>
                            )}
                          </div>
                        </p>

                        <p className="w-[5%]"></p>
                      </div>
                    </div>
                  ))}
                </div>

              
                <div className="md:hidden space-y-4 mt-4 px-4 pb-32">
                  {[...inspection, ...createNew.inspection].map(
                    (List, index) => {
                      const isExisting = index >= inspection.length;
                      const adjustedIndex = isExisting
                        ? index - inspection.length
                        : index;

                      return (
                        <div
                          key={index}
                          className="p-3 border text-xs font-medium text-[#111537] rounded shadow-sm space-y-2 odd:bg-white even:bg-gray-100"
                        >

                          <div className="text-right">
                            <button
                              onClick={() =>
                                handleDeleteItem(
                                  adjustedIndex,
                                  "inspection",
                                  isExisting
                                )
                              }
                              type="button"
                              className="text-red-500 text-xs"
                            >
                              <DeleteIcon color="red" height={12} />
                            </button>
                          </div>
                          <div>
                            <span className="text-xs font-medium text-[#111537]">
                              S.No :
                            </span>{" "}
                            {index + 1}
                          </div>
                          <div>
                            <span className="text-xs font-medium text-[#111537]">
                              Facilities / Building :
                            </span>{" "}
                            {isExisting ? List?.name : List?.productName}
                          </div>
                          <div>
                            <span className="text-xs font-medium text-[#111537]">
                              Location :
                            </span>{" "}
                            {List?.location}
                          </div>
                          
                          <div>
                            <span className="text-xs font-medium text-[#111537]">
                              Schedule :{" "}
                            </span>{" "}
                            {List?.inspectionType}
                          </div>
                          <div className="flex flex-col gap-2">
                            <span className="text-xs font-medium text-[#111537]">
                              Form Selection :
                            </span>

                            {List?.formSelectionName &&
                            List.formSelectionName.length > 0 ? (
                              List.formSelectionName.map((label, idx) => (
                                <div
                                  key={idx}
                                  className="flex items-start gap-2 p-2 bg-white border border-gray-200 rounded-md text-xs text-gray-700 hover:bg-blue-50 transition"
                                >
                                  <div className="flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-textColor-main font-semibold text-[10px]">
                                    {idx + 1}
                                  </div>
                                  <p className="flex-1">{label}</p>
                                </div>
                              ))
                            ) : (
                              <div className="text-xs text-[#111537]">-</div>
                            )}
                          </div>
                          
                        </div>
                      );
                    }
                  )}
                </div>
              </div>
            </div>
                          <div className="flex justify-end gap-4">
                           <CancelButton handleClick={() => Oncancel(-1)} />
                           <SubmitButton isLoading={isLoading} />
                        </div>
          </div>


        </form>
      </div>
      {showPopupEquipment && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in w-[60%] max-h-[80vh] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
            <h2 className="text-lg font-normal text-[12px]">Add Equipment</h2>
            <form onSubmit={handlePopupSubmitEquipmt}>
              <div className="mb-4 flex flex-wrap">
                <NuInput
                  label="Name"
                  placeholder="Name"
                  formik={formik}
                  name="name"
                  width="w-full"
                  new_width="w-full"
                />
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={togglePopupEqupiment}
                  className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2]  hover:bg-gray-300
                        rounded-md flex items-center mr-2 text-textColor-main"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-textColor-main px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
                >
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default EditContractsTest;


